import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M12.68 1.96H3.33a2.083 2.083 0 0 0-2.08 2.07v9.27a.755.755 0 0 0 .75.75h12a.749.749 0 0 0 .75-.75V4.03a2.074 2.074 0 0 0-2.07-2.07ZM2.75 4.03a.585.585 0 0 1 .58-.57h9.35a.563.563 0 0 1 .57.57v1.22H2.75Zm10.5 8.52H2.75v-5.8h10.5Z';
const draw24px =
  'M19.12,3.24H5A2.75,2.75,0,0,0,2.24,6V20a.75.75,0,0,0,.75.75H21.12a.75.75,0,0,0,.75-.75V6A2.75,2.75,0,0,0,19.12,3.24Zm1.25,16H3.74V8.75H20.37Zm0-12H3.74V6A1.25,1.25,0,0,1,5,4.74H19.12A1.25,1.25,0,0,1,20.37,6Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const BrowserTabIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'browserTab'),
) as IconWithRender;

BrowserTabIcon.displayName = 'BrowserTabIcon';
BrowserTabIcon.propTypes = Icon.propTypes;
BrowserTabIcon.renderIcon = (props) => <BrowserTabIcon {...props} />;
export default BrowserTabIcon;
